import { createSlice } from "@reduxjs/toolkit";

export const cartSlice = createSlice({
    name:"cart",
    initialState:{
        constants:[],
        homeproducts:[],
        hero:[],
        brands:[],
        branches:[],
        images:[],
        vision:[],
        products:[],
        lang:`${localStorage.getItem('lang')}`,
        status:false,
        selected:0,
    },
    reducers:{
        setImages: (state,action) => {
            state.images=[];
            state.images=action.payload;
         },
        setBranches: (state,action) => {
            state.branches=[];
            state.branches=action.payload;
         },
        setVision: (state,action) => {
            state.vision=[];
            state.vision=action.payload;
         },
        setConstants: (state,action) => {
            state.constants=[];
            state.constants=action.payload;
         },
        setBrands: (state,action) => {
            state.brands=[];
            state.brands=action.payload;
         },
         setHero: (state,action) => {
            state.hero=[];
            state.hero=action.payload;
         },
         setProducts: (state,action) => {
            state.products=[];
            state.products=action.payload;
         },
         setHomeProducts: (state,action) => {
            state.homeproducts=[];
            state.homeproducts=action.payload;
         },
         setLang : (state) => {
       if(state.lang === 'ar'){
         state.lang='en';
       }else{
         state.lang='ar';
       }
            
         },
         setStatus : (state,action) => {
       
            state.status=action.payload.status;
         },

         setSelected : (state,action) => {
       
            state.selected=action.payload.select;
         },

    }


});


export const {setStatus,setSelected,setHero,setBrands,setConstants,setVision,setBranches,setHomeProducts,setImages,setProducts,setLang} = cartSlice.actions;

export default cartSlice.reducer;